import { Button, ButtonProps, styled } from '@mui/material';

export const StyledButton = styled(Button)<ButtonProps>(({ theme }) => ({
  color: `${theme.palette.text.primary}`,

  '&:hover': {
    textDecoration: 'none',
  },
}));
